import React from "react";
import { Col, Select } from "antd";
import { FormItem } from "Components/form";
import { PARENT_JOB_TYPE } from "Constants/";
import { Controller } from "react-hook-form";

export default function ParentForm({ form, readOnly = false, ...props }) {
  const { control } = form;

  return (
    <Col xs={24} lg={12}>
      <FormItem label="Personel Türü">
        <Controller
          control={control}
          name="civilServantOther"
          as={
            <Select
              style={{ width: "100%" }}
              className={props.readOnly ? "readOnly" : undefined}
            >
              {Object.keys(PARENT_JOB_TYPE).map((d) => (
                <Select.Option key={d} value={d}>
                  {PARENT_JOB_TYPE[d]}
                </Select.Option>
              ))}
            </Select>
          }
        />
      </FormItem>
    </Col>
  );
}
